import { clsx } from 'clsx'
import { ForwardedRef, forwardRef, MouseEvent, ReactNode } from 'react'
import { Gap, getGapStyle, getPaddingStyle, Padding, styles } from 'util/style'
import css from './RoundButton.module.scss'

type Ref = ForwardedRef<HTMLButtonElement>

type Props = {
  children: ReactNode
  className?: string
  danger?: boolean
  disabled?: boolean
  fill?: boolean
  gap?: Gap
  height?: string | number
  onClick?(e: MouseEvent): unknown
  pad?: Padding
  primary?: boolean
  text?: boolean
}

function buildStyle(props: Props) {
  const { height, pad } = props
  const gap = getGapStyle(props.gap)
  const padding = getPaddingStyle(pad)
  return styles({ height, ...gap, ...padding })
}

export const RoundButton = forwardRef((props: Props, ref: Ref) => {
  const {
    children,
    danger,
    disabled,
    fill,
    onClick,
    primary,
    text,
  } = props

  const type = danger ? css.danger : primary ? css.primary : fill ? css.fill : text ? css.text : css.outline
  const style = buildStyle(props)
  const className = clsx(css.button, props.className, type)

  return <button
    className={className}
    disabled={disabled}
    onClick={onClick}
    ref={ref}
    style={style}
  >
    {children}
  </button>
})
